
//-
import { useTranslation } from "react-i18next";
import "../Styles/Epub.css";
import { useState, useEffect, useRef } from "react";
import { EpubReader } from "../Components/EpubReader";
import * as CryptoJS from "crypto-js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import $, { data } from "jquery";
import EpubServices, { Product } from "../Services/Epub";
import plus from "../Images/plus.svg";
import min from "../Images/min.svg";
import reload from "../Images/refresh.svg";
import close from "../Images/close.svg";
import VideoService from "../Services/VideoPlayer";
import Loading from "../Components/Loading";
import { Console } from "console";
import { EpubCFI } from "epubjs";

export enum BookContentType {
  books = "books",
  kalyan = "kalyan",
  kalpatru = "kalpatru",
  magazine = "magazine",
  vivek = "vivek",
}

interface bookmark {
  id: number;
  name: string;
}

const getCurrentSpineDebugInfo = (
  rendition: any,
  fallbackLocation?: any,
  fallbackHref?: string
) => {
  try {
    const book = rendition?.book;
    const spine = book?.book?.spine || book?.spine || rendition?.spine;
    const lastCfi =
      rendition?.location?.start?.cfi ||
      rendition?.location?.start?.href ||
      fallbackHref ||
      fallbackLocation;
    const spineItem = spine && lastCfi ? spine.get(lastCfi) : null;
    const spinePlayOrder =
      spineItem && typeof spineItem.index === "number"
        ? spineItem.index + 1
        : null;

    return {
      hasRendition: !!rendition,
      hasBook: !!book,
      hasSpine: !!spine,
      lastCfi,
      spineItem,
      spineIndex:
        spineItem && typeof spineItem.index === "number"
          ? spineItem.index
          : null,
      spinePlayOrder,
    };
  } catch (err) {
    console.error("getCurrentSpineDebugInfo error:", err);
    return {
      hasRendition: false,
      hasBook: false,
      hasSpine: false,
      lastCfi: fallbackHref || fallbackLocation,
      spineItem: null,
      spineIndex: null,
      spinePlayOrder: null,
    };
  }
};

/** Flatten a nested TOC array (using `subitems`) into a flat list. */
const flattenTocItems = (items: any[], result: any[] = []): any[] => {
  items.forEach((node: any) => {
    result.push(node);
    if (node.subitems && node.subitems.length) {
      flattenTocItems(node.subitems, result);
    }
  });
  return result;
};

const EpubPage = () => {
  var signKey = localStorage.getItem("SignKey");
  var token = localStorage.getItem("Token");
  var userid = localStorage.getItem("UserId");

  console.log("userid in EpubPage:", userid);
  console.log("Token in EpubPage:", token && token.length > 8 ? `${token.substring(0, 4)}...${token.substring(token.length - 4)}` : token);

  // If token or userid missing/invalid -> redirect immediately (before hooks run)
  const _isInvalidAuthImmediate = (v: any) =>
    v === null || v === undefined || v === "null" || v === "undefined" || v === "";

  if (_isInvalidAuthImmediate(userid) || _isInvalidAuthImmediate(token)) {
    const from = window.location.pathname;
    const to = from.replace(/^\/reader/, "") || "/";
    console.log(`Redirecting from ${from} to ${to} because invalid userid/token:`, { userid, token });
    // Force a full-page replacement (immediate) instead of using Navigate hook
    // We avoid calling hooks conditionally and still perform an instant redirect
    window.location.replace(to);
  }

  var currentdate = new Date();
  var todayDate = currentdate
    .toISOString()
    .replace("T", " ")
    .substring(0, 16)
    .replace(".", "")
    .replace(":", "")
    .replace("-", "")
    .replace(" ", "")
    .replace("-", "");

  var url_file = "";
  var xhr = new XMLHttpRequest();
  const epubViewStyles = {
    viewHolder: {
      position: "relative",
      height: "100%",
      width: "100%",
    },
    view: {
      height: "100%",
    },
  };

  const { slug } = useParams();

  let renditionRef = useRef<any>(undefined);
  const tocRef = useRef<any>(undefined);
  const serverTocRef = useRef<any[] | undefined>(undefined);
  const isClosingRef = useRef(false);

  const getSecureKey = (url: any) => {
    let securekey =
      userid +
      "|" +
      todayDate +
      "|" +
      decodeURI(url) +
      "|" +
      signKey +
      "|Website";

    var hash = CryptoJS?.HmacSHA256(securekey, signKey as any);
    securekey = CryptoJS?.enc?.Base64?.stringify(hash);
    return encodeURI(securekey);
  };

  const [page, setPage] = useState("");


  const changeSize = (newSize: any) => {
    setSize(newSize);
  };
  const isShlokWithBracket = (text: string): boolean => {
    const trimmed = text?.trim();
    return (
      trimmed?.startsWith("(") &&
      trimmed?.includes("श्लोक") || trimmed?.startsWith("श्लोक")
    );
  };
  const CurrentTheme = localStorage.getItem("epub-theme");

  const [colortheme, setTheme] = useState<any | String>(undefined);
  const [fontcolor, setFontColor] = useState<any | String>(undefined);
  const [themecolor, setThemeColor] = useState<any>(
    localStorage.getItem("epub-theme")
  );
  const [subHeadings, setSubHeadings] = useState<string>("");
  const [saveSubHead, setSaveSubHead] = useState<string>("");
  const [subHead, setSubHead] = useState<any>("");
  const [currentNavHref, setCurrentNavHref] = useState<string>("");


  const manualSelectUntilRef = useRef<number>(0);
  const initialTocTargetRef = useRef<string>("");
  const pendingInitialTocJumpRef = useRef(false);
  const MANUAL_GUARD_MS = 700;

  const normalizeLocationParts = (value?: string) => {
    if (!value || typeof value !== "string") {
      return { file: "", anchor: "" };
    }

    try {
      const decoded = decodeURIComponent(value).trim();
      const [rawPath, rawAnchor = ""] = decoded.split("#");
      return {
        file: (rawPath.split("?")[0].split("/").pop() || "").toLowerCase(),
        anchor: rawAnchor.split("?")[0].toLowerCase(),
      };
    } catch {
      const [rawPath, rawAnchor = ""] = value.trim().split("#");
      return {
        file: (rawPath.split("?")[0].split("/").pop() || "").toLowerCase(),
        anchor: rawAnchor.split("?")[0].toLowerCase(),
      };
    }
  };

  const hasLocationAnchor = (value?: string) => {
    return !!normalizeLocationParts(value).anchor;
  };

  const matchesLocationTarget = (
    candidate?: string,
    target?: string,
    preferAnchor = true
  ) => {
    const candidateParts = normalizeLocationParts(candidate);
    const targetParts = normalizeLocationParts(target);

    if (!candidateParts.file || !targetParts.file) return false;
    if (candidateParts.file !== targetParts.file) return false;

    if (preferAnchor && targetParts.anchor) {
      return !!candidateParts.anchor && candidateParts.anchor === targetParts.anchor;
    }

    if (targetParts.anchor && candidateParts.anchor) {
      return candidateParts.anchor === targetParts.anchor;
    }

    return true;
  };

  const searchTocEntry = (
    tocItems: any[],
    hrefToMatch: string,
    preferAnchorMatch: boolean
  ): any => {
    for (let item of tocItems) {
      if (item?.href && matchesLocationTarget(item.href, hrefToMatch, preferAnchorMatch)) {
        return { parentLabel: undefined, label: item.label, tocItem: item };
      }

      if (item?.subitems && item.subitems.length > 0) {
        for (let sub of item.subitems) {
          if (sub?.href && matchesLocationTarget(sub.href, hrefToMatch, preferAnchorMatch)) {
            return { parentLabel: item.label, label: sub.label, tocItem: sub };
          }
        }

        const deeper = searchTocEntry(item.subitems, hrefToMatch, preferAnchorMatch);
        if (deeper) {
          return {
            parentLabel: deeper.parentLabel || item.label,
            label: deeper.label,
            tocItem: deeper.tocItem,
          };
        }
      }
    }

    return null;
  };

  const findTocEntry = (tocItems: any[], hrefToMatch: string): any => {
    if (!tocItems || !hrefToMatch) return null;

    const preferAnchorMatch = hasLocationAnchor(hrefToMatch);

    return (
      searchTocEntry(tocItems, hrefToMatch, preferAnchorMatch) ||
      (preferAnchorMatch ? searchTocEntry(tocItems, hrefToMatch, false) : null)
    );
  };
  const normalize = (a: string, b: string) => {
    if (!a || !b) return false;
    try {
      const A = normalizeLocationParts(a).file;
      const B = normalizeLocationParts(b).file;

      if (!A || !B) return false;

      return A === B || A.includes(B) || B.includes(A);
    } catch {
      return false;
    }
  };

  // Build a mapping from normalized srcFile#srcAnchor to PlayOrder from server TOC
  const buildPlayOrderMap = (serverToc: any[]): Map<string, number> => {
    const map = new Map<string, number>();
    if (!serverToc || serverToc.length === 0) return map;

    const canonicalize = (file?: string, anchor?: string) => {
      if (!file) return "";
      try {
        const fn = decodeURIComponent(file).toLowerCase().split("?")[0].split("/").pop() || "";
        const an = anchor ? `#${anchor.toLowerCase()}` : "";
        return `${fn}${an}`;
      } catch {
        return "";
      }
    };

    const processNodes = (nodes: any[]) => {
      nodes.forEach((node: any) => {
        try {
          const srcFile = node.srcFile || node.href || node.file || "";
          const srcAnchor = node.srcAnchor || node.anchor || "";
          const keyWithAnchor = canonicalize(srcFile, srcAnchor);
          const keyFileOnly = canonicalize(srcFile, "");

          if (node.playOrder !== undefined && keyFileOnly) {
            // add both file-only and file+anchor keys to improve matching
            if (keyFileOnly) map.set(keyFileOnly, node.playOrder);
            if (keyWithAnchor) map.set(keyWithAnchor, node.playOrder);
          }

          // Recurse into common child containers
          if (node.subitems && Array.isArray(node.subitems)) {
            processNodes(node.subitems);
          }
          if (node.navigationTree && Array.isArray(node.navigationTree)) {
            processNodes(node.navigationTree);
          }
          if (node.children && Array.isArray(node.children)) {
            processNodes(node.children);
          }
        } catch (err) {
          // ignore individual node errors
        }
      });
    };

    processNodes(serverToc);
    return map;
  };


  const getPlayOrder = (serverToc: any[], href: string): number | null => {
    if (!serverToc || !href) return null;

    try {
      const playOrderMap = buildPlayOrderMap(serverToc);

      // canonicalize incoming href: strip query, decode, lowercase
      const cleaned = decodeURIComponent(href).toLowerCase();
      const withoutQuery = cleaned.split("?")[0];
      const [filePart, anchorPart] = withoutQuery.split("#");
      const filename = (filePart || "").split("/").pop() || "";
      const anchor = anchorPart ? `#${anchorPart}` : "";

      // Try filename#anchor first
      const keyWithAnchor = `${filename}${anchor}`;
      if (keyWithAnchor && playOrderMap.has(keyWithAnchor)) {
        return playOrderMap.get(keyWithAnchor) || null;
      }

      // Then filename-only
      if (filename && playOrderMap.has(filename)) {
        return playOrderMap.get(filename) || null;
      }

      // Fallback: scan serverToc entries using normalize() logic to handle
      // slight mismatches in anchors/paths
      const scanMatch = (nodes: any[]): number | null => {
        for (const node of nodes) {
          const nodeFile = (node.srcFile || node.href || node.file || "").toString();
          const nodeAnchor = (node.srcAnchor || node.anchor || "").toString();
          const candidate = `${nodeFile}${nodeAnchor ? `#${nodeAnchor}` : ""}`;
          try {
            if (normalize(candidate, href)) {
              return node.playOrder !== undefined ? node.playOrder : null;
            }
          } catch {}
          if (node.subitems && Array.isArray(node.subitems)) {
            const r = scanMatch(node.subitems);
            if (r !== null) return r;
          }
          if (node.navigationTree && Array.isArray(node.navigationTree)) {
            const r = scanMatch(node.navigationTree);
            if (r !== null) return r;
          }
          if (node.children && Array.isArray(node.children)) {
            const r = scanMatch(node.children);
            if (r !== null) return r;
          }
        }
        return null;
      };

      const found = scanMatch(serverToc);
      if (found !== null) return found;

      // Final fallback: use epub.js spine index if available (like vanilla js snippet)
      try {
        const lastCfi = renditionRef?.current?.location?.start?.cfi || renditionRef?.current?.location?.start?.href || href;
        const spine = (renditionRef?.current as any)?.book?.book?.spine || (renditionRef?.current as any)?.spine;
        if (spine && lastCfi) {
          const spineItem = spine.get(lastCfi);
          if (spineItem && typeof spineItem.index === "number") {
            return spineItem.index + 1;
          }
        }
      } catch (err) {
        // ignore spine fallback errors
      }

      return null;
    } catch (err) {
      console.error("getPlayOrder error:", err);
      return null;
    }
  };

  /**
   * Compute the correct navOrder (playOrder) for the current reading position
   * matching the exact logic from the legacy epub script.js.
   */
  const computeNavOrderByCFI = (): string => {
    try {
      const rendition = renditionRef.current;
      if (!rendition) return "";

      const last_cfi = rendition.location?.start?.cfi;
      if (!last_cfi) return "";

      const book = rendition.book;
      if (!book) return "";

      // 1. Build tocAnchorMap exactly like script.js
      const tocAnchorMap: Record<string, number> = {};
      let count = 0;
      const walkToc = (items: any[]) => {
        items.forEach((item) => {
          const anchor = item.href ? item.href.split('#')[1] : null;
          if (anchor) {
            tocAnchorMap[anchor] = count + 1; // 1-based navOrder
          }
          count++;
          if (item.subitems && item.subitems.length > 0) {
            walkToc(item.subitems);
          }
        });
      };

      if (book.navigation && book.navigation.toc) {
        walkToc(book.navigation.toc);
      }

      // 2. Get iframe document and find first [id^=toc_marker-]
      const contents = rendition.getContents();
      if (contents && contents.length > 0) {
        const iframeDoc = contents[0].document;
        if (iframeDoc) {
          const marker = iframeDoc.querySelector('[id^="toc_marker-"]');
          if (marker && marker.id) {
            const anchorId = marker.id;
            if (tocAnchorMap[anchorId]) {
              return tocAnchorMap[anchorId].toString();
            }
          }
        }
      }

      // 3. Fallback to spine index + 1
      const spine = book.spine;
      if (spine && last_cfi) {
        const spineItem = spine.get(last_cfi);
        if (spineItem && typeof spineItem.index === "number") {
          return (spineItem.index + 1).toString();
        }
      }

      return "";
    } catch (err) {
      console.error("computeNavOrderByCFI error:", err);
      return "";
    }
  };

  // track whether we've loaded bookmarks at least once for this rendition
  const bookmarksLoadedRef = useRef<boolean>(false);

  // Robust bookmark check used by the UI icon and click handlers
  const isBookmarked = (loc: any) => {
    if (!loc || !showBKdata) return false;
    try {
      return showBKdata.some((i: any) => {
        if (!i) return false;
        if (i.cfi && i.cfi === loc) return true;
        if (i.href && normalize(i.href, loc)) return true;
        if (i.cfi && normalize(i.cfi, loc)) return true;
        return false;
      });
    } catch (err) {
      return false;
    }
  };
  // const handleRelocated = (relocated: any) => {
  //   try {
  //     const newLocation = relocated?.start?.cfi || relocated?.start?.location || undefined;
  //     setLocation(newLocation);

  //     if (manualSelectUntilRef.current && Date.now() < manualSelectUntilRef.current) {
  //       return;
  //     }

  //     const href = relocated?.start?.href || relocated?.start?.indexHref || "";
  //     const displayed = relocated?.start?.displayed;

  //     setPage(
  //       `Page ${displayed?.page} of ${displayed?.total} in chapter ${href ? href : "n/a"}`
  //     );

  //     const toc = tocRef.current;
  //     if (toc && href) {
  //       const found = findTocEntry(toc, href);

  //       if (found) {
  //      
  //         if (found.parentLabel) {
  //           setLastName(found.parentLabel);
  //           setSubHeadings(found.label);
  //           handleSetSaveSubHead(found.label); // ← Save to localStorage
  //         } 
  //      
  //         else if (found.tocItem?.subitems?.length > 0) {
  //        
  //           const activeSubItem = found.tocItem.subitems.find((sub: any) => {
  //             return normalize(sub.href, href);
  //           });

  //           if (activeSubItem) {
  //             setLastName(found.label);
  //             setSubHeadings(activeSubItem.label);
  //             handleSetSaveSubHead(activeSubItem.label);
  //           } else {
  //     
  //             setLastName(found.label);
  //             setSubHeadings("");
  //             handleSetSaveSubHead("");
  //           }
  //         } 
  //         // 3. सिंपल chapter
  //         else {
  //           setLastName(found.label);
  //           setSubHeadings("");
  //           handleSetSaveSubHead("");
  //         }
  //       } else {
  //         // fallback अगर TOC match न हो
  //         if (Array.isArray(toc) && typeof relocated?.start?.index === "number") {
  //           const chapter = toc[relocated.start.index];
  //           setLastName(chapter?.label || "");
  //           setSubHeadings("");
  //           handleSetSaveSubHead("");
  //         }
  //       }
  //     }
  //   } catch (err) {
  //     console.error("handleRelocated error:", err);
  //   } finally {
  //     manualSelectUntilRef.current = 0;
  //   }
  // };
  /**
   * Scans the active content view for toc_marker- IDs and returns the one 
   * currently visible or last passed in the viewport.
   */
  const findCurrentAnchorInDom = (baseHref: string): string | null => {
    if (!renditionRef.current) return null;

    try {
      const contents = (renditionRef.current as any).getContents();
      if (!contents) return null;

      // Find the content object that matches our current base filename
      const activeContent = contents.find((content: any) => {
        const contentHref = content.cfiBase?.href || content.url || "";
        return normalize(contentHref, baseHref);
      });

      if (!activeContent) return null;

      const doc = activeContent.document;
      const markers = Array.from(doc.querySelectorAll('[id^="toc_marker-"]'));

      if (markers.length === 0) return null;

      // Identify the last marker that is at or above the viewport top.
      let currentAnchor = null;
      for (const marker of markers) {
        const rect = (marker as HTMLElement).getBoundingClientRect();
        // Use a threshold (150px) to consider a marker "current" if it's near the top
        if (rect.top <= 150) {
          currentAnchor = (marker as HTMLElement).id;
        } else {
          // Since markers follow document order, we can stop once we see one below the threshold
          break;
        }
      }
      return currentAnchor;
    } catch (err) {
      console.error("Error finding anchor in DOM:", err);
      return null;
    }
  };


  const handleRelocated = (relocated: any) => {
    const timeStamp = Date.now();
    console.log("Relocated event:", { timeStamp, relocated });

    try {
      const newLocation = relocated?.start?.cfi || relocated?.start?.location || undefined;

      if (manualSelectUntilRef.current && Date.now() < manualSelectUntilRef.current) {
        return;
      }

      let href = relocated?.start?.href || relocated?.start?.indexHref || "";
      const displayed = relocated?.start?.displayed;
      const requestedInitialTarget = initialTocTargetRef.current;
      const protectInitialTocJump =
        pendingInitialTocJumpRef.current &&
        state?.type === BookContentType.books &&
        !!requestedInitialTarget;
      const requestedParts = normalizeLocationParts(requestedInitialTarget);

      // If href doesn't have an anchor, try to find one in the DOM for more accuracy
      if (href && !href.includes("#")) {
        const foundAnchor = findCurrentAnchorInDom(href);
        if (
          foundAnchor &&
          (!protectInitialTocJump ||
            !requestedParts.anchor ||
            foundAnchor.toLowerCase() === requestedParts.anchor)
        ) {
          href = `${href}#${foundAnchor}`;
          console.log("DOM Search: Found anchor", foundAnchor, "for", href);
        } else if (foundAnchor && protectInitialTocJump && requestedParts.anchor) {
          console.log("Skipping DOM anchor override during initial TOC jump", {
            href,
            foundAnchor,
            requestedTarget: requestedInitialTarget,
          });
        }
      }

      if (protectInitialTocJump) {
        const exactTargetMatch = matchesLocationTarget(href, requestedInitialTarget, true);
        const sameFileTarget = matchesLocationTarget(href, requestedInitialTarget, false);

        if (!exactTargetMatch) {
          if (sameFileTarget && !hasLocationAnchor(href) && requestedParts.anchor) {
            href = requestedInitialTarget;
            console.log("Preserving requested TOC anchor until first jump settles", {
              href,
              requestedTarget: requestedInitialTarget,
            });
          } else {
            console.log("Ignoring relocated update while initial TOC target is pending", {
              href,
              requestedTarget: requestedInitialTarget,
              newLocation,
            });
            return;
          }
        }

        pendingInitialTocJumpRef.current = false;
        console.log("Initial TOC target resolved", {
          requestedTarget: requestedInitialTarget,
          href,
          newLocation,
        });
      }

      setLocation(newLocation);

      // Track the full href (including anchor if present) for navorder
      setCurrentNavHref(href);

      setPage(
        `Page ${displayed?.page} of ${displayed?.total} in chapter ${href ? href : "n/a"}`
      );

      const toc = tocRef.current;
      if (toc && href) {
        const found = findTocEntry(toc, href);

        if (found) {
          if (found.parentLabel) {
            setLastName(found.parentLabel);

            if (found.label && !isShlokWithBracket(found.label)) {
              setSubHeadings(found.label.trim());
              handleSetSaveSubHead(found.label.trim());
            } else {
              setSubHeadings("");
              handleSetSaveSubHead("");
            }
          }
          else if (found.tocItem?.subitems?.length > 0) {
            const activeSubItem = found.tocItem.subitems.find((sub: any) => {
              return matchesLocationTarget(sub.href, href, hasLocationAnchor(href));
            });

            if (activeSubItem && !isShlokWithBracket(activeSubItem.label)) {
              setLastName(found.label);
              setSubHeadings(activeSubItem.label.trim());
              handleSetSaveSubHead(activeSubItem.label.trim());
            } else {
              setLastName(found.label);
              setSubHeadings("");
              handleSetSaveSubHead("");
            }
          }
          else {
            setLastName(found.label);
            setSubHeadings("");
            handleSetSaveSubHead("");
          }
        }
        else {
          setLastName("");
          setSubHeadings("");
          handleSetSaveSubHead("");
        }
      }
    } catch (err) {
      console.error("handleRelocated error:", err);
    } finally {
      if (!pendingInitialTocJumpRef.current) {
        initialTocTargetRef.current = "";
      }
      manualSelectUntilRef.current = 0;
    }
  };



  const locationChanged = (epubcifi: any) => {
    const timeStamp = Date.now();
    console.log("locationChanged event:", { timeStamp, epubcifi });
    const requestedInitialTarget = initialTocTargetRef.current;
    const protectInitialTocJump =
      pendingInitialTocJumpRef.current &&
      state?.type === BookContentType.books &&
      !!requestedInitialTarget;
    const requestedParts = normalizeLocationParts(requestedInitialTarget);
    
    // Also update currentNavHref from rendition if available
    if (renditionRef?.current?.location?.start) {
      let { href } = renditionRef.current.location.start;
      if (href && !href.includes("#")) {
        const foundAnchor = findCurrentAnchorInDom(href);
        if (
          foundAnchor &&
          (!protectInitialTocJump ||
            !requestedParts.anchor ||
            foundAnchor.toLowerCase() === requestedParts.anchor)
        ) {
          href = `${href}#${foundAnchor}`;
        } else if (foundAnchor && protectInitialTocJump && requestedParts.anchor) {
          console.log("Skipping locationChanged anchor override during initial TOC jump", {
            href,
            foundAnchor,
            requestedTarget: requestedInitialTarget,
          });
        }
      }

      if (protectInitialTocJump) {
        const exactTargetMatch = matchesLocationTarget(href, requestedInitialTarget, true);
        const sameFileTarget = matchesLocationTarget(href, requestedInitialTarget, false);

        if (!exactTargetMatch) {
          if (sameFileTarget && !hasLocationAnchor(href) && requestedParts.anchor) {
            href = requestedInitialTarget;
          } else {
            console.log("Ignoring locationChanged update while initial TOC target is pending", {
              href,
              requestedTarget: requestedInitialTarget,
              epubcifi,
            });
            return;
          }
        }
      }

      setLocation(epubcifi);
      setCurrentNavHref(href || "");
    } else {
      setLocation(epubcifi);
    }

    if (renditionRef?.current && tocRef?.current) {
      const start = renditionRef.current.location?.start;
      if (start) {
        const { displayed, href } = start;
        setPage(
          `Page ${displayed?.page} of ${displayed?.total} in chapter ${href ? href : "n/a"
          }`
        );
      }
    }
  };

  const handleTextSelected = (cfiRange: string, contents: any) => {
    const text = contents.window.getSelection()?.toString();
    console.log("Text selected:", { text, cfiRange });
    if (text && text.trim().length > 0) {
      setSelectedText(text);
      setSelectedCfiRange(cfiRange);
    } else {
      setSelectedText("");
      setSelectedCfiRange("");
    }
  };

  const [toast, setToast] = useState<{ show: boolean; message: string }>({
    show: false,
    message: "",
  });
  const { t } = useTranslation();

  const [lastName, setLastName] = useState("");
  const [savedBookMark, setSavedBookMark] = useState<boolean>(false);
  const [bookName, setBookName] = useState<string>("");
  const [showBKdata, setShowBKdata] = useState<bookmark[] | undefined | any>(
    undefined
  );
  const [showdata, setShowdata] = useState<boolean>(false);
  const [lengthofbkm, setLengthofbkm] = useState<boolean>(false);
  const [showHLdata, setShowHLdata] = useState<any[]>([]);
  const [showHighlightdata, setShowHighlightdata] = useState<boolean>(false);
  const [selectedText, setSelectedText] = useState<string>("");
  const [selectedCfiRange, setSelectedCfiRange] = useState<string>("");

  const locationDetail = useLocation();

  // Restore saved font size from nav state; fall back to 100 for any falsy / NaN value
  const _rawFontSize = (locationDetail?.state as any)?.fontsize;
  const _parsedFontSize = parseFloat(_rawFontSize);
  const _initialSize =
    _rawFontSize !== null &&
      _rawFontSize !== undefined &&
      _rawFontSize !== "" &&
      _rawFontSize !== "null" &&
      !isNaN(_parsedFontSize)
      ? _parsedFontSize
      : 100;

  // size state — seeded from restored font size above
  const [size, setSize] = useState<number | any>(_initialSize);

  const state = locationDetail?.state as {
    bookDetailId: string;
    kalyanDetailId: string;
    kalpatrauDetailId: string;
    magazineDetailId: string;
    vivekvaniDetailId: string;
    bookName: string;
    chapterName: string;
    slug: string;
    type: BookContentType;
    titleName: string;
    location: string;
    tocNode?: any;
    reload: string;
    fontsize?: number;
  };

  const getUrlBytype = (type: BookContentType) => {
    let value = "";
    switch (type) {
      case BookContentType.books:
        value = `books/${state?.bookDetailId}`;
        break;
      case BookContentType.kalyan:
        value = `kalyans/${state?.kalyanDetailId}`;
        break;
      case BookContentType.kalpatru:
        value = `kalyanskalpataru/${state?.kalpatrauDetailId}`;
        break;
      case BookContentType.magazine:
        value = `MonthlyMagazines/${state?.magazineDetailId}`;
        break;
      case BookContentType.vivek:
        value = `vivekVanis/${state?.vivekvaniDetailId}`;
        break;
      default:
        break;
    }
    return value;
  };

  const [url, setUrl] = useState(
    `${process.env.REACT_APP_API_URL}/api/${getUrlBytype(
      state.type
    )}/epubstrem/`
  );

  useEffect(() => {
    if (state?.type) {
      const newUrl = `${process.env.REACT_APP_API_URL}/api/${getUrlBytype(state.type)}/epubstrem/`;
      setUrl(newUrl);
    }
  }, [state?.type, state?.bookDetailId, state?.kalyanDetailId, state?.kalpatrauDetailId, state?.magazineDetailId, state?.vivekvaniDetailId]);

  const [location, setLocation] = useState<any>(undefined);
  const [isSaving, setIsSaving] = useState(false);

  const head = {
    Authorization: "Bearer " + token,
    "X-Signature": getSecureKey(url),
    "X-Plateform": "1",
    "X-Value": todayDate,
  };

  function clickOnTheme(disp: boolean) {
    if (disp) {
      $("#divTheme").removeClass("hidetheme");
    } else {
      $("#divTheme").addClass("hidetheme");
    }
  }

  const saveLstPositionAndClose = () => {
    const positionKey =  "setlastposition"; // single api to save last position for all content types, backend will differentiate based on detailId      

    const detailId =
      state?.bookDetailId ||
      state?.kalyanDetailId ||
      state?.kalpatrauDetailId ||
      state?.magazineDetailId ||
      state?.vivekvaniDetailId;

    const playorder = computeNavOrderByCFI();

    console.log("saveLstPositionAndClose called", {
      detailId,
      location,
      size,
      playorder,
    });
    setIsSaving(true);
    return EpubServices.SaveLastPositionAndClose(
      positionKey,
      detailId,
      location,
      size,
      playorder,
      getBookContentTypeNumber()
    )
      .then((res) => {
        // saved
        console.log("saved " + detailId, res);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };


  const locationRef = useRef(location);
  const sizeRef = useRef(size);

  useEffect(() => {
    locationRef.current = location;
    sizeRef.current = size;
  }, [location, size]);

  useEffect(() => {
    return () => {
      const positionKey = state?.bookDetailId
        ? "setlastposition"
        : state?.kalyanDetailId
          ? "kalyanlastposition"
          : state?.kalpatrauDetailId
            ? "kalyankalpatarulastposition"
            : state?.magazineDetailId
              ? "monthlymagazinelastposition"
              : state?.vivekvaniDetailId
                ? "vivekvanilastposition"
                : "setlastposition";

      const detailId =
        state?.bookDetailId ||
        state?.kalyanDetailId ||
        state?.kalpatrauDetailId ||
        state?.magazineDetailId ||
        state?.vivekvaniDetailId;
      console.log("useEffect cleanup triggered", { detailId, hasLocation: !!locationRef.current, isClosing: isClosingRef.current });
      if (detailId && locationRef.current && !isClosingRef.current) {
        let href = currentNavHref || renditionRef.current?.location?.start?.href || "";
        
        // Final check for anchor in case of abrupt close/scrolling
        if (href && !href.includes("#")) {
          const baseHref = href.split("?")[0];
          const foundAnchor = findCurrentAnchorInDom(baseHref);
          if (foundAnchor) {
            href = `${baseHref}#${foundAnchor}`;
          }
        }

        const playorder = detailId && serverTocRef.current
          ? getPlayOrder(serverTocRef.current, href)?.toString() || ""
          : "";
        const spineDebugInfo = getCurrentSpineDebugInfo(
          renditionRef.current,
          locationRef.current,
          href
        );
        console.log("cleanup SaveLastPositionAndClose called", {
          detailId,
          location: locationRef.current,
          size: sizeRef.current,
          playorder,
          href,
          spineLastCfi: spineDebugInfo.lastCfi,
          spineIndex: spineDebugInfo.spineIndex,
          spinePlayOrder: spineDebugInfo.spinePlayOrder,
          matchedPlayOrder:
            spineDebugInfo.spinePlayOrder !== null &&
            playorder !== "" &&
            spineDebugInfo.spinePlayOrder.toString() === playorder,
          hasRendition: spineDebugInfo.hasRendition,
          hasBook: spineDebugInfo.hasBook,
          hasSpine: spineDebugInfo.hasSpine,
          spineItem: spineDebugInfo.spineItem,
        });
        EpubServices.SaveLastPositionAndClose(

          positionKey,
          detailId,
          locationRef.current,
          sizeRef.current,
          playorder,
          getBookContentTypeNumber()
        ).then((res) => {
          // saved
        });
      }
    };
  }, [state]);


  useEffect(() => {
    if (renditionRef.current) {
      renditionRef.current.themes.fontSize(`${size}%`);
    }
  }, [size]);

  useEffect(() => {
    // set book name from navigation state (prefer explicit bookName, fallback to titleName)
    if (state?.bookName) {
      setBookName(state.bookName);
    } else if (state?.titleName) {
      setBookName(state.titleName);
    }
    // If a location is provided via navigation state (bookmarks / Continue Reading / TOC), use it.
    if (state?.tocNode || state?.location) {
      const stateLocation =
        typeof state?.location === "string" ? state.location.trim() : "";
      let targetLocation = stateLocation;

      if (state?.type === BookContentType.books && state?.tocNode) {
        const srcFile =
          typeof state.tocNode?.srcFile === "string"
            ? state.tocNode.srcFile.trim()
            : "";
        const srcAnchor =
          typeof state.tocNode?.srcAnchor === "string"
            ? state.tocNode.srcAnchor.trim()
            : "";

        if (srcFile) {
          targetLocation = srcAnchor ? `${srcFile}#${srcAnchor}` : srcFile;
        }
      }

      console.log("Initial location from state:", targetLocation);
      console.log("Setting initial location to:", targetLocation);

      if (targetLocation) {
        if (state?.type === BookContentType.books && state?.tocNode) {
          initialTocTargetRef.current = targetLocation;
          pendingInitialTocJumpRef.current = true;
          console.log("Registered initial Book TOC target", { targetLocation });
        } else {
          initialTocTargetRef.current = "";
          pendingInitialTocJumpRef.current = false;
        }
        setLocation(targetLocation);
      }
      if (state?.chapterName) {
        setLastName(state?.chapterName);
        setSubHeadings("");
        console.log("Setting initial chapter name to:", state?.chapterName);
      }
    } else {
      initialTocTargetRef.current = "";
      pendingInitialTocJumpRef.current = false;
    }
    // Note: we intentionally do NOT call the last-position API from this component.
  }, [state?.location, state?.bookDetailId, state?.tocNode, state?.bookName, state?.titleName, state?.chapterName, state?.type]);

  // Fetch server navigation details (TOC with PlayOrder) for all content types
  useEffect(() => {
    const detailId =
      state?.bookDetailId ||
      state?.kalyanDetailId ||
      state?.kalpatrauDetailId ||
      state?.magazineDetailId ||
      state?.vivekvaniDetailId;

    const getNavigationType = (): string => {
      if (state?.bookDetailId) return "book";
      if (state?.kalyanDetailId) return "kalyan";
      if (state?.kalpatrauDetailId) return "kalyankalpatru";
      if (state?.magazineDetailId) return "monthlymagzine";
      if (state?.vivekvaniDetailId) return "vivekvani";
      return "book";
    };

    if (detailId) {
      EpubServices.getNavigationDetails(getNavigationType(), detailId)
        .then((res: any) => {
          if (res?.status && res?.result?.navigationTree) {
            serverTocRef.current = res.result.navigationTree;
            console.log("Server TOC loaded with PlayOrder:", serverTocRef.current?.length || 0, "nodes", "for ID:", detailId);
          }
        })
        .catch((err) => {
          console.error("Failed to load navigation details:", err);
        });
    }
  }, [state?.bookDetailId, state?.kalyanDetailId, state?.kalpatrauDetailId, state?.magazineDetailId, state?.vivekvaniDetailId]);


  // No syncing from API last-position; rely only on `state.location` and user actions.

  useEffect(() => {
    clickOnTheme(false);
  }, []);

  useEffect(() => {
    if (renditionRef.current) {
      renditionRef.current.themes.register("custom", {
        body: {
          // background: colortheme,
          // background: colortheme,
          color: fontcolor,
        },
      });
      renditionRef.current.themes.select("custom");
      if (themecolor === "black") {
        localStorage.setItem("epub-theme", "black");
        $("#titlebar").removeClass("theme-grey");
        $("#titlebar").removeClass("theme-grey");
        $("#titlebar").removeClass("titlebar_color");
        $("#titlebar").addClass("theme-grey");

        $("#test-div").removeClass("theme-white");
        $("#test-div").removeClass("theme-ivory");
        $("#test-div").removeClass("theme-grey");
        $("#test-div").addClass("theme-black");

        $("#test-toc-div").removeClass("theme-white");
        $("#test-toc-div").removeClass("theme-ivory");
        $("#test-toc-div").removeClass("theme-grey");
        $("#test-toc-div").addClass("theme-black");

        $("#test-toc-div button").removeClass("theme-white");
        $("#test-toc-div button").removeClass("theme-ivory");
        $("#test-toc-div button").removeClass("theme-grey");
        $("#test-toc-div button").addClass("theme-black");

        $("#tocwidth").removeClass("theme-white");
        $("#tocwidth").removeClass("theme-ivory");
        $("#tocwidth").removeClass("theme-grey");
        $("#tocwidth").addClass("theme-black");

        renditionRef?.current?.themes?.default({
          // "p.TXT": { color: `${fontcolor}!important` },
          "*": {
            "-webkit-transition": "transform 0.5s ease",
            "-moz-transition": "tranform 0.5s ease",
            "-o-transition": "transform 0.5s ease",
            "-ms-transition": "transform 0.5s ease",
            transition: "transform 0.5s ease",
            "-webkit-touch-callout": "none",
            "-webkit-user-select": "none",
            "-khtml-user-select": "none",
            "-moz-user-select": "none",
            "-ms-user-select": "none",
            "user-select": "none",
          },
          body: {
            // background: "#000000",
            setFontColor: "#ffffff",
            "overflow-wrap": "break-word",
            hyphens: "auto",
          },
          html: {
            "-webkit-filter": "invert(1) hue-rotate(180deg)",
            filter: "invert(1) hue-rotate(180deg)",
          },
          img: {
            "-webkit-filter": "invert(1) hue-rotate(180deg)",
            filter: "invert(1) hue-rotate(180deg)",
          },
        });
      } else if (themecolor === "grey") {
        localStorage.setItem("epub-theme", "grey");
        $("#titlebar").removeClass("theme-grey");
        $("#titlebar").removeClass("theme-black");
        $("#titlebar").removeClass("titlebar_color");
        $("#titlebar").addClass("theme-black");

        $("#test-div").removeClass("theme-white");
        $("#test-div").removeClass("theme-ivory");
        $("#test-div").removeClass("theme-black");
        $("#test-div").addClass("theme-grey");

        $("#test-toc-div").removeClass("theme-white");
        $("#test-toc-div").removeClass("theme-ivory");
        $("#test-toc-div").removeClass("theme-black");
        $("#test-toc-div").addClass("theme-grey");

        $("#test-toc-div button").removeClass("theme-white");
        $("#test-toc-div button").removeClass("theme-ivory");
        $("#test-toc-div button").removeClass("theme-black");
        $("#test-toc-div button").addClass("theme-grey");

        $("#tocwidth").removeClass("theme-white");
        $("#tocwidth").removeClass("theme-ivory");
        $("#tocwidth").removeClass("theme-black");
        $("#tocwidth").addClass("theme-grey");
        renditionRef?.current?.themes?.default({
          // "p.TXT": { color: `${fontcolor}!important` },
          "*": {
            "-webkit-transition": "transform 0.5s ease",
            "-moz-transition": "tranform 0.5s ease",
            "-o-transition": "transform 0.5s ease",
            "-ms-transition": "transform 0.5s ease",
            transition: "transform 0.5s ease",
            "-webkit-touch-callout": "none",
            "-webkit-user-select": "none",
            "-khtml-user-select": "none",
            "-moz-user-select": "none",
            "-ms-user-select": "none",
            "user-select": "none",
          },
          body: {
            // background: "#464646",
            "overflow-wrap": "break-word",
            hyphens: "auto",
          },
          html: {
            "-webkit-filter": "invert(1) hue-rotate(180deg)",
            filter: "invert(1) hue-rotate(180deg)",
          },
          img: {
            "-webkit-filter": "invert(1) hue-rotate(180deg)",
            filter: "invert(1) hue-rotate(180deg)",
          },
        });
      } else if (themecolor === "ivory") {
        localStorage.setItem("epub-theme", "ivory");
        $("#titlebar").removeClass("theme-grey");
        $("#titlebar").removeClass("theme-black");
        $("#titlebar").removeClass("titlebar_color");
        $("#titlebar").addClass("titlebar_color");

        $("#test-div").removeClass("theme-white");
        $("#test-div").removeClass("theme-ivory");
        $("#test-div").removeClass("theme-black");
        $("#test-div").addClass("theme-ivory");

        $("#test-toc-div").removeClass("theme-white");
        $("#test-toc-div").removeClass("theme-ivory");
        $("#test-toc-div").removeClass("theme-black");
        $("#test-toc-div").addClass("theme-ivory");

        $("#test-toc-div button").removeClass("theme-white");
        $("#test-toc-div button").removeClass("theme-ivory");
        $("#test-toc-div button").removeClass("theme-black");
        $("#test-toc-div button").addClass("theme-ivory");

        $("#tocwidth").removeClass("theme-white");
        $("#tocwidth").removeClass("theme-ivory");
        $("#tocwidth").removeClass("theme-black");
        $("#tocwidth").addClass("theme-ivory");
        renditionRef?.current?.themes?.default({
          // "p.TXT": { color: `${fontcolor}!important` },
          "*": {
            "-webkit-transition": "transform 0.5s ease",
            "-moz-transition": "tranform 0.5s ease",
            "-o-transition": "transform 0.5s ease",
            "-ms-transition": "transform 0.5s ease",
            transition: "transform 0.5s ease",
            "-webkit-touch-callout": "none",
            "-webkit-user-select": "none",
            "-khtml-user-select": "none",
            "-moz-user-select": "none",
            "-ms-user-select": "none",
            "user-select": "none",
          },
          body: {
            // background: "#fffcda",
            "overflow-wrap": "break-word",
            hyphens: "auto",
          },
          html: {
            "-webkit-filter": "invert(0) hue-rotate(0)",
            filter: "invert(0) hue-rotate(0)",
          },
          img: {
            "-webkit-filter": "invert(0) hue-rotate(0)",
            filter: "invert(0) hue-rotate(0)",
          },
        });
      } else if (themecolor === "white") {
        localStorage.setItem("epub-theme", "white");
        $("#titlebar").removeClass("theme-grey");
        $("#titlebar").removeClass("theme-black");
        $("#titlebar").removeClass("titlebar_color");
        $("#titlebar").addClass("titlebar_color");

        $("#test-div").removeClass("theme-grey");
        $("#test-div").removeClass("theme-ivory");
        $("#test-div").removeClass("theme-black");
        $("#test-div").addClass("theme-white");

        $("#test-toc-div").removeClass("theme-grey");
        $("#test-toc-div").removeClass("theme-ivory");
        $("#test-toc-div").removeClass("theme-black");
        $("#test-toc-div").addClass("theme-white");

        $("#test-toc-div button").removeClass("theme-grey");
        $("#test-toc-div button").removeClass("theme-ivory");
        $("#test-toc-div button").removeClass("theme-black");
        $("#test-toc-div button").addClass("theme-white");

        $("#tocwidth").removeClass("theme-grey");
        $("#tocwidth").removeClass("theme-ivory");
        $("#tocwidth").removeClass("theme-black");
        $("#tocwidth").addClass("theme-white");
        renditionRef?.current?.themes?.default({
          // "p.TXT": { color: `${fontcolor}!important` },
          "*": {
            "-webkit-transition": "transform 0.5s ease",
            "-moz-transition": "tranform 0.5s ease",
            "-o-transition": "transform 0.5s ease",
            "-ms-transition": "transform 0.5s ease",
            transition: "transform 0.5s ease",
            "-webkit-touch-callout": "none",
            "-webkit-user-select": "none",
            "-khtml-user-select": "none",
            "-moz-user-select": "none",
            "-ms-user-select": "none",
            "user-select": "none",
          },
          body: {
            // background: "#ffffff",
            "overflow-wrap": "break-word",
            hyphens: "auto",
          },
          html: {
            "-webkit-filter": "invert(0) hue-rotate(0)",
            filter: "invert(0) hue-rotate(0)",
          },
          img: {
            "-webkit-filter": "invert(0) hue-rotate(0)",
            filter: "invert(0) hue-rotate(0)",
          },
        });
      }
    }
    // return GetSignKey();
  }, [
    colortheme,
    fontcolor,
    state?.bookDetailId,
    CurrentTheme,
    themecolor,
    localStorage.getItem("epub-theme"),
  ]);
  const [finalName, setFinalName] = useState<string>("");

  const navigate = useNavigate();


  const BookId = state?.bookDetailId;
  const KalyanId = state?.kalyanDetailId;
  const KalpataruId = state?.kalpatrauDetailId;
  const MagazineId = state?.magazineDetailId;
  const VivekId = state?.vivekvaniDetailId;
  const getBookContentTypeNumber = (): number => {
    if (BookId) return 1; // BookLastPosition
    if (KalyanId) return 2; // KalyanLastPosition
    if (KalpataruId) return 3; // KalyanKalpataruLastPosition
    if (MagazineId) return 4; // MonthlyMagazineLastPosition
    if (VivekId) return 5; // VivekVaniLastPosition
    return 1;
  };
  getBookContentTypeNumber()

  const closebutton = () => {
    console.log("closebutton", BookId);
    if (BookId) {
      navigate(`/books/` + state.slug, {
        state: { bookId: state?.bookDetailId },
      });
    }
    if (KalyanId) {
      navigate(`/kalyan/` + state.slug, {
        state: { kalyanId: state?.kalyanDetailId },
      });
    }
    if (KalpataruId) {
      navigate(`/kalyanakalpataru/` + state.slug, {
        state: { kalpatruId: state?.kalpatrauDetailId },
      });
    }
    if (MagazineId) {
      navigate(`/geetgovind/` + state.slug, {
        state: { MonthId: state?.magazineDetailId },
      });
    }
    if (VivekId) {
      navigate(`/vivekvani/` + state?.slug, {
        state: { vivekvaniId: state?.vivekvaniDetailId },
      });
    }
  };

  const [bookmarkLimit] = useState(10);

  const SaveBookMark = async () => {
    if (showBKdata?.length < bookmarkLimit) {
      let res;
      if (state?.bookDetailId) {
        res = await EpubServices.savebookmark(
          "bookmarks",
          state?.bookDetailId,
          location,
          finalName || lastName
        );
      } else if (state?.kalyanDetailId) {
        res = await EpubServices.savebookmark(
          "kalyanbookmarks",
          state?.kalyanDetailId,
          location,
          finalName
        );
      } else if (state?.kalpatrauDetailId) {
        res = await EpubServices.savebookmark(
          "kalyankalpatarubookmarks",
          state?.kalpatrauDetailId,
          location,
          finalName
        );
      } else if (state?.magazineDetailId) {
        res = await EpubServices.savebookmark(
          "monthlymagazinebookmarks",
          state?.magazineDetailId,
          location,
          finalName
        );
      } else if (state?.vivekvaniDetailId) {
        res = await EpubServices.savevivekvanimark(
          state?.vivekvaniDetailId,
          location,
          finalName
        );
      }

      if (res?.status) {
        setSavedBookMark(!savedBookMark);
        showNotification(
          localStorage.getItem("lan") === "hindi"
            ? "बुकमार्क को सफलतापूर्वक जोड़ा गया |"
            : "Bookmark added successfully"
        );
      }
    } else {
      setSavedBookMark(!savedBookMark);
      showNotification(
        localStorage.getItem("lan") === "hindi"
          ? "आपने इस पुस्तक के लिए अधिकतम बुकमार्क सीमा पार कर ली है। नए जोड़ने के लिए कृपया कुछ बुकमार्क हटाएँ |"
          : "You have exceeded the maximum bookmark limit fir this book. Please delete a few to add new ones"
      );
    }
  };

  const showNotification = (message: any) => {
    setToast({ show: true, message });
    const cleartimeout = setTimeout(() => {
      setToast({ show: false, message: "" });
    }, 2000);
    return () => clearTimeout(cleartimeout);
  };
  const getBookKey = () => {
    return (
      state?.bookDetailId ||
      state?.kalyanDetailId ||
      state?.kalpatrauDetailId ||
      state?.magazineDetailId ||
      state?.vivekvaniDetailId ||
      "unknown"
    );
  };


  // const handleSetSaveSubHead = (subHead: string) => {
  //   const key = `epub-subhead-${getBookKey()}`;
  //   localStorage.setItem(key, subHead);     
  //   setSaveSubHead(subHead);                
  // };
  const handleSetSaveSubHead = (subHead: string) => {
    if (!subHead || isShlokWithBracket(subHead)) {
      const key = `epub-subhead-${getBookKey()}`;
      localStorage.removeItem(key);
      setSaveSubHead("");
      return;
    }

    const key = `epub-subhead-${getBookKey()}`;
    localStorage.setItem(key, subHead.trim());
    setSaveSubHead(subHead.trim());
  };

  // useEffect(() => {
  //   const key = `epub-subhead-${getBookKey()}`;
  //   const saved = localStorage.getItem(key);
  //   if (saved) {
  //     setSaveSubHead(saved);                
  //   }
  // }, [state]); 

  useEffect(() => {
    const key = `epub-subhead-${getBookKey()}`;
    const saved = localStorage.getItem(key);

    if (saved && isShlokWithBracket(saved)) {
      localStorage.removeItem(key);
      setSaveSubHead("");
    } else if (saved) {
      setSaveSubHead(saved.trim());
    }
  }, [state]);

  const RemoveBookMark = async () => {
    let res;
    if (state?.bookDetailId) {
      res = await EpubServices.removebookmark(
        "bookmarks",
        state?.bookDetailId,
        location
      );
    }
    if (state?.kalyanDetailId) {
      res = await EpubServices.removebookmark(
        "kalyanbookmarks",
        state?.kalyanDetailId,
        location
      );
    }
    if (state?.kalpatrauDetailId) {
      res = await EpubServices.removebookmark(
        "kalyankalpatarubookmarks",
        state?.kalpatrauDetailId,
        location
      );
    }
    if (state?.magazineDetailId) {
      res = await EpubServices.removebookmark(
        "monthlymagazinebookmarks",
        state?.magazineDetailId,
        location
      );
    }
    if (state?.vivekvaniDetailId) {
      res = await EpubServices.deletevivekmark(
        "vivekvanimarks",
        state?.vivekvaniDetailId,
        location
      );
    }

    if (res?.status) {
      setSavedBookMark(!savedBookMark);
      showNotification(
        localStorage.getItem("lan") === "hindi"
          ? "बुकमार्क को सफलतापूर्वक हटाया गया |"
          : "Bookmark removed successfully"
      );
    }
  };

  const getSavedBookmarks = () => {
    if (state.bookDetailId) {
      EpubServices.getbookmark("bookmarks", state?.bookDetailId).then(
        (res: any) => {
          if (res.status) {
            setShowBKdata(res?.result);

            res.result.length > 0
              ? setLengthofbkm(true)
              : setLengthofbkm(false);

          }
        }
      );
    }
    if (state?.kalyanDetailId) {
      EpubServices.getbookmark("kalyanbookmarks", state?.kalyanDetailId).then(
        (res: any) => {
          if (res.status) {
            setShowBKdata(res?.result);

            res.result.length > 0
              ? setLengthofbkm(true)
              : setLengthofbkm(false);

          }
        }
      );
    }
    if (state?.kalpatrauDetailId) {
      EpubServices.getbookmark(
        "kalyankalpatarubookmarks",
        state?.kalpatrauDetailId
      ).then((res: any) => {
        if (res.status) {
          setShowBKdata(res?.result);
          res.result.length > 0
            ? setLengthofbkm(true)
            : setLengthofbkm(false);
        }
      });
    }
    if (state?.magazineDetailId) {
      EpubServices.getbookmark(
        "monthlymagazinebookmarks",
        state?.magazineDetailId
      ).then((res: any) => {
        if (res.status) {
          setShowBKdata(res?.result);
          res.result.length > 0
            ? setLengthofbkm(true)
            : setLengthofbkm(false);

        }
      });
    }
    if (state?.vivekvaniDetailId) {
      EpubServices.getvivekvanimark(state?.vivekvaniDetailId).then(
        (res: any) => {
          if (res.status) {
            setShowBKdata(res?.result);
            res.result.length > 0
              ? setLengthofbkm(true)
              : setLengthofbkm(false);

          }
        }
      );
    }
  };

  const getProductType = (): number => {
    if (state?.bookDetailId) return Product.Book;
    if (state?.kalyanDetailId) return Product.Kalyan;
    if (state?.kalpatrauDetailId) return Product.KalyanKalpataru;
    if (state?.magazineDetailId) return Product.MonthlyMagazine;
    if (state?.vivekvaniDetailId) return Product.VivekVani;
    return Product.Book;
  };

  const getSavedHighlights = () => {
    const detailId = state?.bookDetailId || state?.kalyanDetailId || state?.kalpatrauDetailId || state?.magazineDetailId || state?.vivekvaniDetailId;
    if (detailId) {
      EpubServices.getHighlights(getProductType(), detailId).then((res: any) => {
        if (res.status) {
          setShowHLdata(res?.result || []);
        }
      });
    }
  };

  const SaveHighlight = async () => {
    const detailId = state?.bookDetailId || state?.kalyanDetailId || state?.kalpatrauDetailId || state?.magazineDetailId || state?.vivekvaniDetailId;
    if (!detailId || !selectedCfiRange || !selectedText) return;

    // Extract start CFI from range: epubcfi(... , /start, /end) -> epubcfi(... /start)
    let startCfi = selectedCfiRange;
    if (selectedCfiRange.includes(",")) {
      const parts = selectedCfiRange.split(",");
      if (parts.length >= 2) {
        startCfi = parts[0] + parts[1];
        if (!startCfi.endsWith(")")) startCfi += ")";
      }
    }

    let hColor = "#FF8B33"; // Default white theme
    if (themecolor === "ivory") hColor = "#E67E22";
    else if (themecolor === "grey") hColor = "#3498DB";
    else if (themecolor === "black") hColor = "#E74C3C";

    const res = await EpubServices.saveHighlight(
      getProductType(),
      detailId,
      startCfi,
      selectedCfiRange,
      selectedText,
      hColor,
      lastName || bookName
    );

    if (res?.status) {
      showNotification(
        localStorage.getItem("lan") === "hindi"
          ? "हाइलाइट सफलतापूर्वक जोड़ा गया ।"
          : "Highlight added successfully"
      );
      setSelectedText("");
      setSelectedCfiRange("");
      getSavedHighlights();
    }
  };

  const handleDeleteHighlight = async (cfiRange: string) => {
    const detailId = state?.bookDetailId || state?.kalyanDetailId || state?.kalpatrauDetailId || state?.magazineDetailId || state?.vivekvaniDetailId;
    if (!detailId) return;

    const res = await EpubServices.removeHighlight(getProductType(), detailId, cfiRange);
    if (res?.status) {
      showNotification(
        localStorage.getItem("lan") === "hindi"
          ? "हाइलाइट सफलतापूर्वक हटाया गया ।"
          : "Highlight removed successfully"
      );
      getSavedHighlights();
    }
  };

  useEffect(() => {
    getSavedBookmarks();
    getSavedHighlights();
  }, [savedBookMark]);

  const handleDelete = async (dataCfi: any) => {
    let res;
    if (state?.bookDetailId) {
      res = await EpubServices.removebookmark(
        "bookmarks",
        state?.bookDetailId,
        dataCfi
      );
    }
    if (state?.kalyanDetailId) {
      res = await EpubServices.removebookmark(
        "kalyanbookmarks",
        state?.kalyanDetailId,
        dataCfi
      );
    }
    if (state?.kalpatrauDetailId) {
      res = await EpubServices.removebookmark(
        "kalyankalpatarubookmarks",
        state?.kalpatrauDetailId,
        dataCfi
      );
    }
    if (state?.magazineDetailId) {
      res = await EpubServices.removebookmark(
        "monthlymagazinebookmarks",
        state?.magazineDetailId,
        dataCfi
      );
    }
    if (state?.vivekvaniDetailId) {
      res = await EpubServices.deletevivekmark(
        "vivekvanimarks",
        state?.vivekvaniDetailId,
        dataCfi
      );
    }

    if (res?.status) {
      setSavedBookMark(!savedBookMark);
      showNotification(
        localStorage.getItem("lan") === "hindi"
          ? "बुकमार्क को सफलतापूर्वक हटाया गया |"
          : "Bookmark removed successfully"
      );
    }
  };

  // useEffect(() => {
  //   if (state?.bookDetailId) {
  //     BooksService.getBookDetail(state?.bookDetailId, "").then((res: any) => {
  //       setBookName(res?.result?.name);
  //     });
  //   }
  //   if (state?.kalyanDetailId) {
  //     KalyansServices.getcurrentKalyan(state?.kalyanDetailId, "").then(
  //       (res) => {
  //         setBookName(res?.result?.name);
  //       }
  //     );
  //   }
  //   if (state?.kalpatrauDetailId) {
  //     KalpataruServices.getcurrentKalpatarul(state?.kalpatrauDetailId, "").then(
  //       (res) => {
  //         setBookName(res?.result?.name);
  //       }
  //     );
  //   }
  //   if (state?.magazineDetailId) {
  //     GeetGovindServices.getcurrentMagazine(state?.magazineDetailId, "").then(
  //       (res) => {
  //         setBookName(res?.result?.name);
  //       }
  //     );
  //   }
  //   if (state?.vivekvaniDetailId) {
  //     VivekService.VikekDetailService(state.vivekvaniDetailId, "").then(
  //       (res: any) => {
  //         setBookName(res?.result?.name);
  //       }
  //     );
  //   }
  // }, [bookName]);

  useEffect(() => {
    let url = "";

    if (state?.bookDetailId) {
      url = `books/${state.bookDetailId}`;
    } else if (state?.kalyanDetailId) {
      url = `kalyans/${state.kalyanDetailId}`;
    } else if (state?.kalpatrauDetailId) {
      url = `kalyanskalpataru/${state.kalpatrauDetailId}`;
    } else if (state?.magazineDetailId) {
      url = `MonthlyMagazines/${state.magazineDetailId}`;
    } else if (state?.vivekvaniDetailId) {
      url = `vivekVanis/${state.vivekvaniDetailId}`;
    }

    if (url) {
      const parts = url.split("/");
      if (parts.length === 2) {
        const bookTitle = parts[0];
        const BookId = parts[1];
        const currentTime = new Date().toISOString();
        VideoService.updateUserActivity(bookTitle, BookId, currentTime);
      }
    }
  }, [state]);

  // -------------------------
  // RENDER
  // -------------------------

  return (
    <div>
      <div
        className="d-flex bd-highlight example-parent"
        id="titlebar"
        style={{ backgroundColor: "#ff8b33", color: "#ffffff" }}
      >

        <div
          className="p-2 flex-grow-1 bd-highlight col-example"
          style={{
            marginTop: "5px",
            marginLeft: "45px",
          }}
        >
          <label id="BName" style={{ fontSize: "larger" }}>
            {bookName} : {lastName}
            {saveSubHead && !isShlokWithBracket(saveSubHead)
              ? ` : ${saveSubHead.length > 180 ? saveSubHead.slice(0, 180) + "..." : saveSubHead}`
              : ""}
          </label>
        </div>

        <div className="p-2 bd-highlight col-example">
          <div style={{ flex: "100%", marginTop: "7px" }}>
            <div style={{ flex: "100%", display: "flex" }}>
              <div
                id="bookmark-list"
                style={{
                  border: "none",
                  display: showBKdata?.length < 1 ? "none" : "block",
                }}
                onClick={() => setShowdata((prev) => !prev)}
              ></div>
              <div
                id="highlight-list"
                className="highlight-list-icon"
                style={{
                  border: "none",
                  display: showHLdata?.length < 1 ? "none" : "block",
                  marginLeft: "10px",
                  cursor: "pointer",
                }}
                onClick={() => setShowHighlightdata((prev) => !prev)}
              ></div>
              <div
                id={`bkicon  ${finalName}`}
                className={isBookmarked(location) ? "bookmarkicon-fill" : "bookmarkicon"}
                style={{ display: selectedText ? "none" : "block" }}
                onClick={() => {
                  !isBookmarked(location) ? SaveBookMark() : RemoveBookMark();
                }}
              ></div>
              {selectedText && (
                <div
                  className="highlight-btn-icon"
                  style={{
                    marginLeft: "10px",
                    cursor: "pointer",
                  }}
                  onClick={SaveHighlight}
                  title="Highlight selection"
                ></div>
              )}
              <img
                alt=""
                style={{ width: "22px" }}
                src={min}
                onClick={() => {
                  changeSize(Math.max(50, size - 10));
                }}
              />
              <div
                style={{
                  paddingLeft: "5px",
                  paddingRight: "5px",
                  fontSize: "18px",
                }}
              >
                {size}%
              </div>
              <img
                alt="plus"
                style={{ width: "22px", marginRight: "13px" }}
                src={plus}
                onClick={() => changeSize(Math.min(130, size + 10))}
              />
              <img
                alt="reload"
                style={{ width: "19px" }}
                src={reload}
                onClick={() => {
                  setTheme("#ffffff");
                  setFontColor("#000000");
                  clickOnTheme(false);
                  setThemeColor("white");
                  setSize(100);
                }}
              />
              <div
                className="icon-theme"
                onClickCapture={() => {
                  clickOnTheme(true);
                }}
              >
                <div id="theme">
                  <div id="divTheme" className="col">
                    <div className="row" style={{ margin: 0 }}>
                      <a
                        id="btnThemeWhite"
                        className="theme-btn-white"
                        onClick={() => {
                          setThemeColor("white");
                          setTheme("#ffffff");
                          setFontColor("#000000");
                          clickOnTheme(false);
                        }}
                      ></a>
                    </div>
                    <div className="row" style={{ margin: 0 }}>
                      <a
                        id="btnThemeIvory"
                        className="theme-btn-ivory"
                        onClick={() => {
                          setThemeColor("ivory");
                          setTheme("#fffcda");
                          setFontColor("#000000");
                          clickOnTheme(false);
                        }}
                      />
                    </div>
                    <div className="row" style={{ margin: 0 }}>
                      <a
                        id="btnThemeGrey"
                        className="theme-btn-grey"
                        onClick={() => {
                          setThemeColor("grey");
                          setTheme("#464646");
                          setFontColor("#ffffff");
                          clickOnTheme(false);
                        }}
                      />
                    </div>
                    <div className="row" style={{ margin: 0 }}>
                      <a
                        id="btnThemeBlack"
                        className="theme-btn-black"
                        onClick={() => {
                          setThemeColor("black");
                          clickOnTheme(false);
                          setTheme("#000000");
                          setFontColor("#ffffff");
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <img id="close-btn"
                alt="close"
                src={close}
                width="18px"
                style={{ cursor: "pointer" }}
                onClick={async () => {
                  isClosingRef.current = true;
                  await saveLstPositionAndClose();
                  closebutton();
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div>
        {showdata === true && lengthofbkm === true ? (
          <div
            style={{
              width: "18%",
              height: "auto",
              position: "absolute",
              right: "5px",
              zIndex: 1,
              background: "antiquewhite",
            }}
          >
            <ul className="bklistul" style={{ listStyle: "none" }}>
              {showBKdata &&
                showBKdata?.map((data: any, index: number) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      key={index}
                    >
                      <li
                        className="bklistitem"
                        key={data.id}
                        onClick={() => {
                          setLocation(data?.cfi);
                          setFinalName(data?.name);
                          manualSelectUntilRef.current =
                            Date.now() + MANUAL_GUARD_MS;
                          if (tocRef.current && data?.href) {
                            const found = findTocEntry(
                              tocRef.current,
                              data.href
                            );
                            if (found) {
                              if (found.parentLabel) {
                                setLastName(found.parentLabel);
                                setSubHeadings(found.label);
                              } else {
                                setLastName(found.label);
                                setSubHeadings("");
                              }
                            }
                          } else {
                            setLastName(data?.name || "");
                          }
                          setShowdata(false);
                        }}
                      >
                        {data?.name}
                      </li>
                      <label
                        onClick={() => {
                          handleDelete(data?.cfi);
                        }}
                        className="bookmark_del fa fa-trash"
                        style={{
                          marginRight: "40px",
                          color: "red",
                          border: "none",
                          background: "none",
                          fontSize: "24px",
                          cursor: "pointer",
                        }}
                      ></label>
                    </div>
                  );
                })}
            </ul>
          </div>
        ) : (
          <div style={{ display: "none", position: "relative" }}></div>
        )}
      </div>

      <div>
        {showHighlightdata === true && showHLdata?.length > 0 ? (
          <div
            style={{
              width: "22%",
              height: "auto",
              maxHeight: "400px",
              overflowY: "auto",
              position: "absolute",
              right: "5px",
              top: "50px",
              zIndex: 10,
              background: "antiquewhite",
              padding: "10px",
              borderRadius: "5px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            }}
          >
            <h4 style={{ textAlign: "center", color: "#666" }}>Highlights</h4>
            <ul className="bklistul" style={{ listStyle: "none", padding: 0 }}>
              {showHLdata.map((data: any, index: number) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 0",
                    borderBottom: "1px solid #ddd",
                  }}
                  key={index}
                >
                  <li
                    className="bklistitem"
                    style={{ fontSize: "16px", flexGrow: 1, cursor: "pointer", paddingRight: "10px" }}
                    onClick={() => {
                      setLocation(data?.cfi);
                      setShowHighlightdata(false);
                    }}
                  >
                    <span style={{ backgroundColor: data?.color, padding: "2px" }}>
                      {data?.content?.length > 50 ? data.content.substring(0, 50) + "..." : data.content}
                    </span>
                  </li>
                  <label
                    onClick={() => {
                      handleDeleteHighlight(data?.cfiRange);
                    }}
                    className="fa fa-trash"
                    style={{
                      color: "red",
                      fontSize: "18px",
                      cursor: "pointer",
                    }}
                  ></label>
                </div>
              ))}
            </ul>
          </div>
        ) : null}
      </div>

      <div
        style={{
          margin: "50px 40% auto",
          textAlign: "center",
          zIndex: 1,
          position: "absolute",
        }}
      >
        {toast.show && (
          <div
            className="modal-content"
            style={{
              backgroundColor: "#FF8B33",
              color: "#fff",
              fontSize: "22px",
              fontFamily: "ChanakyaUni",
              padding: "5px 8px",
            }}
          >
            {toast.message}
          </div>
        )}
      </div>

      <div style={{ height: "93vh" }} className="myReader">
        {isSaving && <Loading message={t("saving_last_position_tr")} />}
        {(state?.bookDetailId || state?.kalyanDetailId || state?.kalpatrauDetailId || state?.magazineDetailId || state?.vivekvaniDetailId) && (
        <EpubReader
          location={location}
          locationChanged={locationChanged}
          setSaveSubHead={handleSetSaveSubHead}
          handleTextSelected={handleTextSelected}
          //         subHeading={(h) =>{
          // const trimText = (text: string) =>
          //   text?.length > 20 ? text.slice(0, 20) + "..." : text;
          // setLastName(trimText(h));
          //           // setLastName(h)
          //         }}

          subHeading={(h) => {
            const trimText = (text: string) =>
              text?.length > 20 ? text.slice(0, 20) + "..." : text;
            setLastName(trimText(h));
          }}
          url={url}
          epubInitOptions={{ requestHeaders: head }}
          // onTocSelect={(
          //   label: any,
          //   subLabel: any,
          //   href?: string,
          //   cfi?: string
          // ) => {
          //   console.log(href,"aaasdfwewer")
          //   manualSelectUntilRef.current = Date.now() + MANUAL_GUARD_MS;

          //   const finalTitle = subLabel ? `${label} : ${subLabel}` : label;

          //   if (subLabel) {
          //     setLastName(label);
          //     setSubHeadings(subLabel);
          //     setSaveSubHead(subLabel)
          //   } else {
          //     setLastName(label);
          //     setSubHeadings("");
          //     setSaveSubHead("");
          //   }
          //   setFinalName(finalTitle);

          //   if (cfi) {
          //     setLocation(cfi);
          //   } else if (href) {
          //     setLocation(href);
          //   }
          // }}

          //           onTocSelect={(label:any, subLabel:any, href?:any, cfi?:any) => {
          //   manualSelectUntilRef.current = Date.now() + MANUAL_GUARD_MS;

          //   if (subLabel) {
          //     setLastName(label);
          //     setSubHeadings(subLabel);
          //     handleSetSaveSubHead(subLabel);
          //   } else {
          //     setLastName(label);
          //     setSubHeadings("");
          //     handleSetSaveSubHead("");
          //   }
          //   setFinalName(subLabel ? `${label} : ${subLabel}` : label);

          //   if (cfi) setLocation(cfi);
          //   else if (href) setLocation(href);
          // }}


          onTocSelect={(label: any, subLabel: any, href?: any, cfi?: any) => {
            manualSelectUntilRef.current = Date.now() + MANUAL_GUARD_MS;

            if (subLabel && !isShlokWithBracket(subLabel)) {
              setLastName(label);
              setSubHeadings(subLabel.trim());
              handleSetSaveSubHead(subLabel.trim());
              setFinalName(`${label} : ${subLabel.trim()}`);
            } else {
              setLastName(label);
              setSubHeadings("");
              handleSetSaveSubHead("");
              setFinalName(label);
            }

            if (cfi) setLocation(cfi);
            else if (href) setLocation(href);
          }}
          tocChanged={(toc: any) => {
            tocRef.current = toc;
          }}
          getRendition={(rendition) => {
            renditionRef.current = rendition;
            renditionRef.current.themes.fontSize(`${size}%`);

            // register custom theme (kept same behavior)
            rendition.themes.register("custom", {
              body: {
                padding: "20px",
                color:
                  CurrentTheme === "black" || CurrentTheme === "grey"
                    ? "#ffffff"
                    : "#000000",
                "font-family": "ChanakyaUni",
              },
            });
            rendition.themes.select("custom");

            // ensure bookmarks are loaded once the rendition is available
            if (!bookmarksLoadedRef.current) {
              try {
                getSavedBookmarks();
              } catch (err) {
                // ignore
              }
              bookmarksLoadedRef.current = true;
            }

            try {
              rendition.off && rendition.off("relocated", "");
            } catch (e) { }
            rendition.on &&
              rendition.on("relocated", (location: any) => {
                handleRelocated(location);
              });

            rendition.on &&
              rendition.on("mousedown", () => {
                console.log("Mousedown detected, clearing selection");
                setSelectedText("");
                setSelectedCfiRange("");
              });

            const currentLoc = rendition.location && rendition.location.start;
            if (currentLoc) {
              handleRelocated({ start: currentLoc });
            }
          }}
          epubOptions={{
            infinite: true,
            overflow: undefined,
          }}
        />
        )}
      </div>
    </div>
  );
};
export default EpubPage;
